<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Edit Audits
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <template v-if="pageReady">
                                        <div class="grid">
                                            <div class="col-12">
                                                <form ref="observer"  tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                                    <!--[form-content-start]-->
                                                    <div class="grid">
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    User Type 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrluser_type" v-model.trim="formData.user_type"  label="User Type" type="text" placeholder="Enter User Type"      
                                                                    class=" w-full" :class="getErrorClass('user_type')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('user_type')" class="p-error">{{ getFieldError('user_type') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    User Id 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrluser_id" v-model.trim="formData.user_id"  label="User Id" type="number" placeholder="Enter User Id"   step="any"    
                                                                    class=" w-full" :class="getErrorClass('user_id')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('user_id')" class="p-error">{{ getFieldError('user_id') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Event *
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlevent" v-model.trim="formData.event"  label="Event" type="text" placeholder="Enter Event"      
                                                                    class=" w-full" :class="getErrorClass('event')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('event')" class="p-error">{{ getFieldError('event') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Auditable Type *
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlauditable_type" v-model.trim="formData.auditable_type"  label="Auditable Type" type="text" placeholder="Enter Auditable Type"      
                                                                    class=" w-full" :class="getErrorClass('auditable_type')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('auditable_type')" class="p-error">{{ getFieldError('auditable_type') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Auditable Id *
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlauditable_id" v-model.trim="formData.auditable_id"  label="Auditable Id" type="number" placeholder="Enter Auditable Id"   step="any"    
                                                                    class=" w-full" :class="getErrorClass('auditable_id')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('auditable_id')" class="p-error">{{ getFieldError('auditable_id') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Old Values 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <Textarea :class="getErrorClass('old_values')" class="w-full" ref="ctrlold_values" rows="5"  v-model="formData.old_values" placeholder="Enter Old Values"    type="textarea">
                                                                    </Textarea>
                                                                    <small v-if="isFieldValid('old_values')" class="p-error">{{ getFieldError('old_values') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    New Values 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <Textarea :class="getErrorClass('new_values')" class="w-full" ref="ctrlnew_values" rows="5"  v-model="formData.new_values" placeholder="Enter New Values"    type="textarea">
                                                                    </Textarea>
                                                                    <small v-if="isFieldValid('new_values')" class="p-error">{{ getFieldError('new_values') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Url 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <Textarea :class="getErrorClass('url')" class="w-full" ref="ctrlurl" rows="5"  v-model="formData.url" placeholder="Enter Url"    type="textarea">
                                                                    </Textarea>
                                                                    <small v-if="isFieldValid('url')" class="p-error">{{ getFieldError('url') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Ip Address 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlip_address" v-model.trim="formData.ip_address"  label="Ip Address" type="text" placeholder="Enter Ip Address"      
                                                                    class=" w-full" :class="getErrorClass('ip_address')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('ip_address')" class="p-error">{{ getFieldError('ip_address') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    User Agent 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrluser_agent" v-model.trim="formData.user_agent"  label="User Agent" type="text" placeholder="Enter User Agent"      
                                                                    class=" w-full" :class="getErrorClass('user_agent')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('user_agent')" class="p-error">{{ getFieldError('user_agent') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Tags 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrltags" v-model.trim="formData.tags"  label="Tags" type="text" placeholder="Enter Tags"      
                                                                    class=" w-full" :class="getErrorClass('tags')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('tags')" class="p-error">{{ getFieldError('tags') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--[form-content-end]-->
                                                    <div v-if="showSubmitButton" class="text-center my-3">
                                                        <Button type="submit" label="Update" icon="pi pi-send" :loading="saving" />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="loading">
                                        <div class="p-3 text-center">
                                            <ProgressSpinner style="width:50px;height:50px" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useEditPage } from '@/composables/editpage.js';
	const props = defineProps({
		id: [String, Number],
		pageName: {
			type: String,
			default: 'audits',
		},
		routeName: {
			type: String,
			default: 'auditsedit',
		},
		pagePath: {
			type : String,
			default : 'audits/edit',
		},
		apiPath: {
			type: String,
			default: 'audits/edit',
		},
		submitButtonLabel: {
			type: String,
			default: "Update",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterUpdate: {
			type: String,
			default: "Record updated successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
	});
	const app = useApp();
	const formDefaultValues = Object.assign({
		user_type: "", 
		user_id: "", 
		event: "", 
		auditable_type: "", 
		auditable_id: "", 
		old_values: "", 
		new_values: "", 
		url: "", 
		ip_address: "", 
		user_agent: "", 
		tags: "", 
	}, props.pageData);
	const formData = reactive({ ...formDefaultValues });
	function onFormSubmited(response) {
		app.flashMsg(props.msgAfterUpdate);
		if(props.redirect) app.navigateTo(`/audits`);
	}
	const rules = computed(() => {
		return {
			user_type: {  },
			user_id: { numeric },
			event: { required },
			auditable_type: { required },
			auditable_id: { required, numeric },
			old_values: {  },
			new_values: {  },
			url: {  },
			ip_address: {  },
			user_agent: {  },
			tags: {  }
		}
	});
	const v$ = useVuelidate(rules, formData); //form validation
	const page = useEditPage(props, formData, v$, onFormSubmited);
	//page state
	const {
		submitted, // form api submitted state - Boolean
		saving, // form api submiting state - Boolean
		loading, // form data loading state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page computed propties
	const {
		apiUrl, // page current api path
		currentRecord, // current page record  - Object
	} = page.computedProps
	//page methods
	const { 
		load, // get editable form data from api
		submitForm, // submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Edit Audits";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
		load();
	});
</script>
<style scoped>
</style>
